import { OptionTypes } from 'src/components/FormikComponents/DropDown';

export const ADD_USER_INITIAL_VALUES = {
    hierarchyLevel: '',
    partner: '',
    partnerOfPartner: '',
    merchant: '',
    firstName: '',
    lastName: '',
    mobileNumber: '',
    email: '',
    userRole: '',
    worldPaySeller: false,
    sellerId: '',
    pipeDrive: false,
    pipeDriveUserId: '',
    technicalSupportAccess: false,
    zenDeskUserId: '',
    countryCode: '',
};

export const ADD_USER_ROLE_INITIAL_VALUES = {
    name: '',
    description: '',
    hierarchyLevel: '',
    partner: '',
    partnerOfPartner: '',
};

export const ROUTES = {
    partner: {
        addPartner: '/partner/add',
        listPartner: '/partners',
        editPartner: '/partner/edit',
    },
    merchant: {
        addMerchant: '/merchant/add',
        listMerchant: '/merchants',
        editMerchant: '/merchant/edit',
        viewMerchantApplications: '/merchant-applications/view',
        cancelMerchant: '/merchant/cancel',
        listTrialMerchants: '/trial-merchants',
    },
    userManagement: {
        manageUsers: '/user-management/users',
        manageRoles: '/user-management/user-roles',
    },
    mcc: {
        listMcc: '/mccs',
    },
    productAndPricing: {
        productsCatalogue: {
            products: '/products',
        },
        terminalPricing: {
            pricings: '/terminal-pricing',
        },
        transactionPricing: {
            pricing: '/transaction-pricing',
        },
        onlinePricing: {
            pricing: '/online-pricing',
        },
        partnerShops: {
            shops: '/partner-shops',
        },
    },
    configuration: {
        cancellationReasons: '/config/cancellation-reasons',
        suspendedReasons: '/config/suspended-reasons',
        auditLogs: {
            viewAuditLog: '/config/audit-log',
        },
        removeStockReasons: '/config/remove-stock-reasons',
        configurePartnerResources: '/config/partner-resources',
        checkInCallSetup: '/config/check-in-call-setup',
    },
    finance: {
        salesInvoices: '/finance/sales-invoices',
        credits: '/finance/credits',
        accountStatements: '/finance/account-statements',
        directDebits: '/finance/direct-debits',
        selfBillingInvoices: '/finance/self-billing-invoices',
        commissions: {
            online: '/finance/commissions/online',
            transaction: '/finance/commissions/transaction',
            terminal: '/finance/commissions/terminal',
        },
    },
    partnerResources: {
        viewPartnerResources: '/partner-resources/view',
        managePartnerResources: '/partner-resources/manage',
    },
    customerSuccess: {
        checkInCalls: '/customer-success/check-in-calls',
    },
};

export const USER_MANAGEMENT_TABLE_HEADERS = [
    {
        id: 'username',
        label: 'Username',
    },
    {
        id: 'statusChip',
        label: 'Status',
    },
    {
        id: 'role',
        label: 'User Role',
    },
    {
        id: 'email',
        label: 'Email',
    },
    {
        id: 'phoneNumber',
        label: 'Contact',
    },

    {
        id: 'partner',
        label: 'Partner/Partner Of Partner',
        align: 'center',
    },
    {
        id: 'hierarchyLevel',
        label: 'Hierarchy Level',
    },
];

export const USER_ROLES_TABLE_HEADERS = [
    {
        id: 'role',
        label: 'User Role',
        minWidth: '168px',
    },
    {
        id: 'hierarchyLevel',
        label: 'Hierarchy Level',
        minWidth: '242px',
        align: 'center',
    },
    {
        id: 'users',
        label: 'Current Users',
        minWidth: '242px',
        align: 'center',
    },
    {
        id: 'createdAt',
        label: 'Date Added',
        minWidth: '242px',
        align: 'center',
    },
];

export const USER_ROLES_MODAL_TABLE_HEADERS = [
    {
        id: 'username',
        label: 'User Name',
    },
    {
        id: 'email',
        label: 'Email',
    },
    {
        id: 'phoneNumber',
        label: 'Phone Number',
    },
    {
        id: 'status',
        label: 'Status',
    },
];

export const PARTNER_TABLE_HEADERS = [
    {
        id: 'name',
        label: 'Partner Name',
    },
    {
        id: 'type',
        label: 'Partner Type',
    },
    {
        id: 'primaryContactName',
        label: 'Primary Contact Name',
    },
    {
        id: 'topLevelPartner',
        label: 'Top Level Partner',
    },
    {
        id: 'status',
        label: 'Status',
    },
];

export const MERCHANT_TABLE_HEADERS = [
    {
        id: 'merchantAccountNumber',
        label: 'Merchant Account Number',
    },
    {
        id: 'applicationId',
        label: 'Application ID',
    },
    {
        id: 'mid',
        label: 'MID (Merchant ID)',
    },
    {
        id: 'tradingName',
        label: 'Trading Name',
    },
    {
        id: 'partnerName',
        label: 'Partner Name',
    },
    {
        id: 'dateAdded',
        label: 'Date Added',
    },
    {
        id: 'status',
        label: 'Status',
    },
];

export const ONLINE_SERVICE_PRICING_OFFERS_TABLE_HEADERS = [
    {
        id: 'offerId',
        label: 'Offer ID',
    },
    {
        id: 'offerName',
        label: 'Offer Name',
    },
    {
        id: 'partnerName',
        label: 'Partner Name',
    },
    {
        id: 'assignedTo',
        label: 'Assigned To Total',
    },
    {
        id: 'status',
        label: 'Status',
    },
];

export const PRODUCT_AND_PRICING_OFFERINGS_TABLE_HEADERS = [
    {
        id: 'description',
        label: 'Description',
    },
    {
        id: 'dateCreated',
        label: 'Date/Time',
    },
];

export const HISTORY_TABLE_HEADERS = [
    {
        id: 'dateCreated',
        label: 'Date/Time',
    },
    {
        id: 'description',
        label: 'Description',
    },
    {
        id: 'createdBy',
        label: 'Added By',
    },
];

export const SERVICES_TABLE_HEADERS = [
    {
        id: 'id',
        label: 'Service ID',
    },
    {
        id: 'tradingName',
        label: 'Trading Name',
    },
    {
        id: 'serviceType',
        label: 'Service Type',
    },
    {
        id: 'product',
        label: 'Product',
    },
    {
        id: 'dateAdded',
        label: 'Date Added',
        type: 'Date',
    },
    {
        id: 'status',
        label: 'Status',
    },
    {
        id: 'contractExpiry',
        label: 'Contract Expiry',
        type: 'Date',
    },
    {
        id: 'promosText',
        label: 'Promos',
    },
    {
        id: 'promoExpiryDate',
        label: 'Promo Expiry',
        type: 'Date',
    },
];

export const CANCELLATION_REASONS_TABLE_HEADERS = [
    {
        id: 'description',
        label: 'Description',
    },
    {
        id: 'dateCreated',
        label: 'Date Created',
    },
    {
        id: 'status',
        label: 'Status',
    },
];

export const REMOVE_STOCK_REASONS_TABLE_HEADERS = [
    {
        id: 'description',
        label: 'Description',
    },
    {
        id: 'dateCreated',
        label: 'Date Created',
    },
];

export const COMMISSIONS_TABLE_HEADERS = [
    {
        id: 'commissionStatementId',
        label: 'ID',
    },
    {
        id: 'partnerName',
        label: 'Partner Name',
    },
    {
        id: 'totalCommission',
        label: 'Commission',
    },
    {
        id: 'statementDate',
        label: 'Statement Date',
    },
    {
        id: 'dateCreated',
        label: 'Date Added',
    },
    {
        id: 'selfBillingInvoiceId',
        label: 'Self-Billing Invoice',
    },
    {
        id: 'status',
        label: 'Status',
    },
];

export const MCCS_TABLE_HEADERS = [
    {
        id: 'code',
        label: 'MCC Number',
    },
    {
        id: 'description',
        label: 'MCC Description',
    },
    {
        id: 'name',
        label: 'MCC Friendly Name',
    },
    {
        id: 'risk',
        label: 'Risk Classification',
    },
];

export const PRODUCTS_TABLE_HEADERS = [
    {
        id: 'productId',
        label: 'Product ID',
    },
    {
        id: 'name',
        label: 'Product Name',
    },
    {
        id: 'type',
        label: 'Product Type',
    },
    {
        id: 'catalogue',
        label: 'Primary/Secondary',
    },
    {
        id: 'statusChip',
        label: 'Status',
    },
];

export const CREDITS_TABLE_HEADERS = [
    {
        label: 'Credit Note Number',
        id: 'sageCreditNoteNumber',
    },
    {
        label: 'Merchant Name',
        id: 'merchant.business.legalName',
    },
    {
        label: 'Partner Name',
        id: 'partner.business.legalName',
    },
    {
        label: 'Date Added',
        id: 'createdAt',
    },
    {
        label: 'Invoice Number',
        id: 'salesInvoice.sageInvoiceNumber',
    },
    { label: 'Credit Value', id: 'totalInvoiceAmount' },
];

export const PAYMENTS_TABLE_HEADERS = [
    {
        id: 'id',
        label: 'ID',
    },
    {
        id: 'name',
        label: 'Payment',
    },
    {
        id: 'amount',
        label: 'Amount',
    },
    {
        id: 'status',
        label: 'Status',
    },
];

export const PARTNER_SHOPS_TABLE_HEADERS = [
    {
        id: 'id',
        label: 'Shop ID',
    },
    {
        id: 'name',
        label: 'Shop Name',
    },
    {
        id: 'dateCreated',
        label: 'Date Created',
    },
    {
        id: 'status',
        label: 'Status',
    },
];

// these column headers are used in online offers, terminal offers and transaction offers
export const PRICING_OFFER_TABLE_HEADERS = [
    {
        id: 'idPrefix',
        label: 'Offer ID',
    },
    {
        id: 'name',
        label: 'Offer Name',
    },
    {
        id: 'partnerName',
        label: 'Partner Name',
    },
    {
        id: 'assignToTotal',
        label: 'Assign To Total',
    },
    {
        id: 'statusChip',
        label: 'Status',
    },
];

export const AUDIT_LOGS_TABLE_HEADERS = [
    {
        id: 'user',
        label: 'User',
    },

    {
        id: 'entity',
        label: 'Audit Log Entity',
    },
    {
        id: 'entityId',
        label: 'Audit Log Entity ID',
    },
    {
        id: 'event',
        label: 'Event Type',
    },
    {
        id: 'createdAt',
        label: 'Date Time',
    },
];

export const AUDIT_LOGS_CSV_TABLE_HEADERS = [
    {
        id: 'user',
        label: 'User',
    },
    {
        id: 'ipAddress',
        label: 'IP Address',
    },
    {
        id: 'hierarchyLevel',
        label: 'Hierarchy Level',
    },

    {
        id: 'entity',
        label: 'Audit Log Entity',
    },
    {
        id: 'entityId',
        label: 'Audit Log Entity ID',
    },
    {
        id: 'event',
        label: 'Event Type',
    },
    {
        id: 'details',
        label: 'Details',
    },
    {
        id: 'createdAt',
        label: 'Date Time',
    },
];

// TODO: Remove this once the commissions APIs are ready
export const COMMISSIONS_TABLE_DATA = [
    {
        commissionId: 1001,
        partnerName: 'Acme Corporation',
        commissionAmount: '500.00',
        statementDate: '15/08/2023',
        dateCreated: '08/10/2023',
        invoiceNumber: 'INV-001',
        status: 'ACTIVE',
    },
    {
        commissionId: 1002,
        partnerName: 'XYZ Ltd',
        commissionAmount: '800.00',
        statementDate: '08/18/2023',
        dateCreated: '08/12/2023',
        invoiceNumber: 'INV-002',
        status: 'DEACTIVATED',
    },
    {
        commissionId: 1003,
        partnerName: 'Global Enterprises',
        commissionAmount: '350.00',
        statementDate: '20/08/2023',
        dateCreated: '08/14/2023',
        invoiceNumber: 'INV-003',
        status: 'DELETED',
    },
    {
        commissionId: 1004,
        partnerName: 'ABC Industries',
        commissionAmount: '600.00',
        statementDate: '22/08/2023',
        dateCreated: '08/16/2023',
        invoiceNumber: 'INV-004',
        status: 'DEACTIVATED',
    },
    {
        commissionId: 1005,
        partnerName: 'Tech Solutions Inc.',
        commissionAmount: '750.00',
        statementDate: '25/08/2023',
        dateCreated: '08/18/2023',
        invoiceNumber: 'INV-005',
        status: 'ACTIVE',
    },
];

export const SALES_INVOICE_TABLE_HEADERS = [
    {
        id: 'id',
        label: 'ID',
    },
    {
        id: 'to',
        label: 'Partner/Merchant',
    },
    {
        id: 'date',
        label: 'Statement Date',
    },
    {
        id: 'createdAt',
        label: 'Added Date',
    },
    {
        id: 'status',
        label: 'Status',
    },
];

export const HIERARCHIES = [
    { value: 'NPI', label: 'NPI' },
    { value: 'PARTNER', label: 'Partner' },
    { value: 'PARTNER_OF_PARTNER', label: 'Partner of Partner' },
    { value: 'MERCHANT', label: 'Merchant' },
];

export enum UserHierarchies {
    NPI = 'NPI',
    PARTNER = 'Partner',
    PARTNER_OF_PARTNER = 'Partner of Partner',
    MERCHANT = 'Merchant',
}

export enum Hierarchy {
    NPI = 'NPI',
    PARTNER = 'PARTNER',
    PARTNER_OF_PARTNER = 'PARTNER_OF_PARTNER',
    MERCHANT = 'MERCHANT',
}

export enum Statuses {
    PENDING = 'PENDING',
    REVIEWING = 'REVIEWING',
    APPROVED = 'APPROVED',
    SUSPENDED = 'SUSPENDED',
}

export enum PartnerStatuses {
    ACTIVE = 'ACTIVE',
    CANCELLED = 'CANCELLED',
    SUSPENDED = 'SUSPENDED',
}

export enum UserStatuses {
    ACTIVE = 'ACTIVE',
    PENDING = 'PENDING',
    SUSPENDED = 'SUSPENDED',
    NOT_ACTIVATED = 'NOT_ACTIVATED',
    LOCKED = 'LOCKED',
}

export enum MerchantStatuses {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    CANCELLED = 'CANCELLED',
    SUSPENDED = 'SUSPENDED',
}

export enum InvoiceStatus {
    ACTIVE = 'ACTIVE',
    DEACTIVATED = 'DEACTIVATED',
    DELETED = 'DELETED',
}

export enum InvoicePaymentStatus {
    PAID = 'PAID',
    PARTIALLY_PAID = 'PARTIALLY_PAID',
    UNPAID = 'UNPAID',
    VOID = 'VOID',
}

export enum ProductType {
    ONLINE = 'ONLINE',
    TERMINAL = 'TERMINAL',
}

export enum CreditNoteStatus {
    CREDITED = 'Fully Credited',
    PARTIALLY_CREDITED = 'Partially Credited',
    OPEN = 'Open',
}

export enum PaymentAllocationStatus {
    ALLOCATED = 'ALLOCATED',
    UNALLOCATED = 'UNALLOCATED',
}

export const ACCESS_TOKEN_KEY = 'access_token';

export const BUSINESS_TYPES = {
    PUBLIC_LIMITED_COMPANY: 'PUBLIC_LIMITED_COMPANY',
    LIMITED_LIABILITY_PARTNERSHIP: 'LIMITED_LIABILITY_PARTNERSHIP',
    PARTNERSHIP: 'PARTNERSHIP',
    SOLE_TRADER: 'SOLE_TRADER',
    CHARITY_OR_NOT_FOR_PROFIT: 'CHARITY_OR_NOT_FOR_PROFIT',
    PRIVATE_LIMITED_COMPANY: 'PRIVATE_LIMITED_COMPANY',
};

export const PARTNER_SUB_NAVIGATION = [
    { step: 'partnerType', label: 'Partner Type' },
    { step: 'partnerInformation', label: 'Partner Information' },
    { step: 'paymentInformation', label: 'Payment Information' },
    { step: 'pricingInformation', label: 'Pricing Information' },
    { step: 'contractInformation', label: 'Contract Information' },
];

export const PARTNER_CONTACT_INFORMATION_SUB_NAVIGATION = [
    { step: 'primaryContact', label: 'Primary Contact' },
    { step: 'billingContact', label: 'Billing Contact' },
    { step: 'serviceContact', label: 'Service Contact' },
];

export const TITLE_OPTIONS: OptionTypes[] = [
    { label: 'Mr', value: 'MR' },
    { label: 'Miss', value: 'MISS' },
    { label: 'Ms', value: 'MS' },
    { label: 'Mrs', value: 'MRS' },
    { label: 'Dr', value: 'DR' },
    { label: 'Other', value: 'OTHER' },
];

export const TRANSACTION_PRICING_TABLE_HEADERS = [
    {
        id: 'offerId',
        label: 'Offer ID',
    },
    {
        id: 'offerName',
        label: 'Offer Name',
    },
    {
        id: 'partnerName',
        label: 'Partner Name ',
    },
    {
        id: 'assignToTotal',
        label: 'Assign To Total',
    },
    {
        id: 'status',
        label: 'Status',
    },
];

export const PRODUCT_AND_PRICING_OFFERINGS_SUB_NAVIGATION = [
    { step: 'terminal', label: 'Terminal' },
    { step: 'online', label: 'Online' },
    { step: 'transaction', label: 'Transaction' },
];

export const INPROGRESS_MERCHANT_APPLICATION_HEADERS = [
    {
        id: 'id',
        label: 'Application ID',
    },
    {
        id: 'partnerName',
        label: 'Partner Name',
    },
    {
        id: 'serviceType',
        label: 'Service Type',
    },
    {
        id: 'merchantName',
        label: 'Trading Name',
    },
    {
        id: 'sellersName',
        label: `Seller's Name`,
    },
    {
        id: 'dateSubmitted',
        label: 'Date Submitted',
    },
    {
        id: 'worldpayPO',
        label: 'Worldpay PO',
    },
    {
        id: 'status',
        label: 'Status',
    },
];
export const SEPA_DD_COMMON_AGREEMENT_HEADERS = [
    {
        id: 'accountNumber',
        label: 'Account Number',
    },
    {
        id: 'status',
        label: 'Status',
    },
    {
        id: 'contactName',
        label: 'Contact Name',
    },
    {
        id: 'sentToEmail',
        label: `Sent To`,
    },
    {
        id: 'addedByName',
        label: 'Added By',
    },
];
export const SEPA_DD_MERCHANT_AGREEMENT_HEADERS = [
    {
        id: 'tradingName',
        label: 'Merchant',
    },
    ...SEPA_DD_COMMON_AGREEMENT_HEADERS,
];

export const SEPA_DD_PARTNER_AGREEMENT_HEADERS = [
    {
        id: 'tradingName',
        label: 'Partner',
    },
    ...SEPA_DD_COMMON_AGREEMENT_HEADERS,
];

export const SELF_BILLING_INVOICES_HEADERS = [
    {
        id: 'id',
        label: 'ID',
    },
    {
        id: 'partnerName',
        label: 'Partner Name',
    },
    {
        id: 'invoiceDate',
        label: 'Invoice Date',
    },
    {
        id: 'dateAdded',
        label: 'Date Added',
    },
    {
        id: 'status',
        label: 'Status',
    },
];
export const BOX_SHADOW = '0px 4px 20px 0px rgba(38, 50, 56, 0.10)';
export const DEFAULT_BORDER_WIDTH = '1px';
export const DEFAULT_BORDER_STYLE = 'solid';
export const DEFAULT_BORDER_RADIUS = '16px';

export const DEFAULT_BORDER = {
    borderColor: 'border.primary',
    borderWidth: DEFAULT_BORDER_WIDTH,
    borderStyle: DEFAULT_BORDER_STYLE,
    borderRadius: DEFAULT_BORDER_RADIUS,
};

export const CREDIT_NOTE_LINE_ITEM_COLUMN_HEADERS = [
    'Ledger Account',
    'Description',
    'Quantity',
    'Net Amount',
    'Total Line Vat',
    'Line Total',
];

export const RESOURCE_TABLE_HEADERS = [
    {
        id: 'name',
        label: 'Resource Name',
    },
    {
        id: 'type',
        label: 'Category',
    },
];
export const RESOURCES_TABLE_HEADERS = [
    {
        id: 'name',
        label: 'Resource Name',
    },
    {
        id: 'section.name',
        label: 'Section Name',
    },
    {
        id: 'type',
        label: 'Category',
    },
    {
        id: 'status',
        label: 'Status',
    },
];

export const mimeTypes = {
    images: {
        'image/jpeg': [
            '.jpeg',
            '.jpg',
            '.png',
            '.JPEG',
            '.JPG',
            '.PNG',
            '.Jpeg',
            '.Jpg',
            '.png',
            '.jPeg',
            '.jPg',
            '.Png',
            '.jpEg',
            '.jpg',
            '.pNg',
            '.jpeG',
            '.jpG',
            '.pnG',
        ],
    },
    documents: {
        'application/pdf': ['.pdf'],
        'application/msword': ['.doc'],
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
        'application/vnd.ms-excel': ['.xls'],
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
    },
    videos: {
        'video/mp4': ['.mp4'],
        'video/quicktime': ['.mov'],
        'video/x-msvideo': ['.avi'],
        'video/webm': ['.webm'],
    },
};

export type CountryCodes = 'IE' | 'GB' | 'XI';
